import React, { useCallback } from 'react';
import styled from 'styled-components';
import { actions } from '@/store';
import { useDispatch } from 'react-redux';
import useSelectorUser from '@/hooks/use-selector-user';
import media from '@/styles/media';
import { hideAuthModal } from '../../..';

export const Logo = () => {
  const { onClose } = useSelectorUser('authModal');
  const dispatch = useDispatch();

  const onLogoClick = useCallback(() => {
    dispatch(actions.user.authModal.init());
    hideAuthModal();
    if (onClose) onClose();
  }, [dispatch, onClose]);

  return (

    <LogoImg
      onClick={onLogoClick}
      src="/assets/images/common/STEAMuP-logo-v4.png"
      alt="logo"
    />
  );
};

const LogoImg = styled.img`
  width: 145px;
  height: 32px;
  ${media.lg`
    display: none;
  `}
`;
